export default class Service {

    constructor() {
        this.init();
    }

    init() {

        this.tab();
    }

    tab() {

        const tabChange = (target) => {
            $('.division.active').removeClass('active');
            $('.division#' + target).addClass('active');
        }

        $('.js-tab_trigger').on('click', function () {
            $('.js-tab_trigger.active').removeClass('active');
            const tgt = $(this).attr('data-tab');

            $('[data-tab="' + tgt + '"]').addClass('active');

            tabChange(tgt);

            //下ナビの場合はスクロール
            if ($(this).parents('.bottomnav').length > 0) {
                var speed = $(this).attr('data-speed') || 600;
                $('body,html').animate({ scrollTop: 0 }, speed, 'swing');
            };
        });

    }

}